import React, { useState, useEffect } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
//i18n
import { withTranslation } from "react-i18next"
import { FaQuestion, FaUser } from "react-icons/fa"
import { RiStockFill } from "react-icons/ri"
import ConfigUrl, { axiosbaseurl } from "../../config"
import Loader from "pages/Loader"
import ProfitLossChart from "./Chart"
import { usePermissionData } from "AppContext"
import { useNavigate } from "react-router-dom"
import StockData from "./Dashboard_data"
import PayoutChart from "./PayoutChart"
import moment from "moment"

const Dashboard = props => {
  document.title = "Dashboard | Return First Investments"
  const Navigate = useNavigate()

  const { checkAccess } = usePermissionData()

  const [Loading, setLoading] = useState(false)
  const [Data, setData] = useState([])
  const [ChartData, setChartData] = useState([])
  const [Payouts, setPayouts] = useState([])
  const [selectedUser, setSelectedUser] = useState(null)
  const [users, setusers] = useState([])
  const [ShortData, setShortData] = useState({})

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`dashboard/stats`)
      if (response?.data?.success) {
        setData(response?.data?.data)
        setusers(response?.data?.customers)
        setSelectedUser(response?.data?.customers?.[0]?.id)
      }
    } catch (e) {
      console.log("Error", e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (selectedUser) {
      getChartData()
      getLongData()
    }
  }, [selectedUser])

  async function getChartData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.post(
        `dashboard/stats/portfolio/data`,
        {
          customerId: selectedUser,
        }
      )
      if (response?.data?.success) {
        setChartData(response?.data?.data || [])
        setPayouts(
          response?.data?.data?.payouts.filter(
            item => item?.Type === "PAYMENT"
          ) || []
        )
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  async function getLongData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.post(
        `dashboard/stats/long/term/data`,
        {
          customerId: selectedUser,
        }
      )
      if (response?.data?.success) {
        setShortData(response?.data || {})
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
      setShortData({})
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          {/* <Breadcrumbs title={""} breadcrumbItem={props.t("Dashboard")} /> */}
          <h6 className="mb-3 fs-5 ps-3">Welcome Back</h6>
          <Row>
            {/* <Col md="3">
              <WelcomeComp />
            </Col> */}
            <Col md="3">
              <Card
                className="mini-stats-wid mb-3"
                style={{ cursor: "pointer" }}
                onClick={() => Navigate(`${ConfigUrl.appurl}customers`)}
              >
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h5 className=" fw-medium">Customers</h5>
                      <h4 className="mb-0">{Data?.customerCount}</h4>
                    </div>
                    <div className="avatar-sm rounded-circle align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle">
                        <FaUser fontSize={24} />
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="3">
              <Card
                className="mini-stats-wid mb-0"
                style={{ cursor: "pointer" }}
                onClick={() => Navigate(`${ConfigUrl.appurl}users`)}
              >
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h5 className=" fw-medium">Staff</h5>
                      <h4 className="mb-0">{Data?.userCount - 1}</h4>
                    </div>
                    <div className="avatar-sm rounded-circle align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle">
                        <RiStockFill fontSize={24} />
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="3">
              {/* <Card
                className="mini-stats-wid mb-3"
                style={{ cursor: "pointer" }}
                onClick={() => Navigate(`${ConfigUrl.appurl}portfolio`)}
              >
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h5 className=" fw-medium">Portfolios</h5>
                      <h4 className="mb-0">{Data?.portfolioCount}</h4>
                    </div>
                    <div className="avatar-sm rounded-circle align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle">
                        <MdOutlineTipsAndUpdates fontSize={24} />
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card> */}
              <Card
                className="mini-stats-wid mb-0"
                style={{ cursor: "pointer" }}
                onClick={() => Navigate(`${ConfigUrl.appurl}contact-enquiry`)}
              >
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h5 className=" fw-medium">Contact Enquiry</h5>
                      <h4 className="mb-0">{Data?.enquiryCount}</h4>
                    </div>
                    <div className="avatar-sm rounded-circle align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle">
                        <FaQuestion fontSize={24} />
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="3">
              <Card
                className="mini-stats-wid mb-3"
                style={{ cursor: "pointer" }}
                onClick={() => Navigate(`${ConfigUrl.appurl}tips`)}
              >
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h5 className=" fw-medium">News & Update</h5>
                      <h4 className="mb-0">{Data?.tipCount}</h4>
                    </div>
                    <div className="avatar-sm rounded-circle align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle">
                        <FaUser fontSize={24} />
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
              {/* <Card className="mini-stats-wid mb-0">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                        <h5 className=" fw-medium">Staffs</h5>
                        <h4 className="mb-0">{Data?.portfolioCount}</h4>
                    </div>
                    <div className="avatar-sm rounded-circle align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle">
                        <RiStockFill fontSize={24}/>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card> */}
            </Col>
          </Row>

          {checkAccess(3, 1) && selectedUser && (
            <Card className="mt-3">
              <Card>
                <ProfitLossChart
                  selectedUser={selectedUser}
                  setSelectedUser={setSelectedUser}
                  data={ChartData}
                  users={users}
                />
              </Card>
              <StockData data={ShortData} />
              <PayoutChart data={Payouts} />
            </Card>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(Dashboard)
